import axios from 'axios'
import Banner from 'components/body/Banner'
import DownloadsSection from 'components/body/DownloadsSection'
import ResponsiveImage from 'components/core/ResponsiveImage'
import Footer from 'components/layout/Footer'
import Env from 'Env'
import HTTPMethod from 'http-method-enum'
import Markdown from 'markdown-to-jsx'
import { GetStaticProps } from 'next'
import Head from 'next/head'
import React, { Fragment } from 'react'
import { Converters } from 'services/Converters'

type Props = {
  page: any
  footer: any
}

export default function SoftwareDownloadPage(props: Props) {
  const attr = props.page.data.attributes
  return (
    <Fragment>
      <Head>
        <title>SecureMyEmail - Software Download</title>
      </Head>
      <div className="font-openSans text-sm font-medium">
        <div className="inner-banner lg:pt-[45px] md:pb-[135px] pt-[50px] pb-[100px] bg-inner-banner bg-center bg-no-repeat bg-cover text-center z-10 relative text-2xl text-white font-lato">
          <div className="container">
            <div className="w-full text-center md:text-left mb-12 sm:mb-20">
              <a className="logo" href="/">
                <ResponsiveImage extraClassNames="transition-all w-32 sm:w-[196px] h-auto" data={attr.logo} />
              </a>
            </div>
            <h2 className="lg:text-[50px] md:text-[35px] font-lato text-[30px] font-bold leading-[1em] m-0 p-0 text-white">SecureMyEmail Software & Apps</h2>
            <p className="text-[#c2c1ca]">Enjoy your encrypted email on all your devices.</p>
          </div>
        </div>

        <section className="md:pt-[100px] bg-shape-white bg-no-repeat bg-top -mt-[72px] pt-[50px] relative z-10 mb-12 md:mb-20">
          <div className="container">
            <div className="text-center mb-12 md:mb-20">
              <ResponsiveImage extraClassNames="mx-auto" isFullWidth data={attr.heroImage} />
            </div>
            <div className="download-info max-w-[970px] mx-auto mb-12 md:mb-24 grid gap-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
              {attr.steps.map((step: any, index: number) => (
                  <div key={step.id} className="item-box bg-[#FAFAFD] rounded-[15px] w-full px-[34px] pb-8 pt-[100px] text-center shadow-[0_3px_6px_0_rgba(0,0,0,0.08)] relative">
                    <h2
                      id="step-1"
                      className="bg-[#645BF0] font-lato font-bold text-white text-[25px] pt-[8px] w-11 h-11 rounded-full flex justify-center items-center
                      absolute left-1/2 top-[30px] -translate-x-1/2"
                    >
                      {step.title}
                    </h2>
                    <h3 className="font-lato font-bold text-xl text-[#360371] p-0 m-0">{step.description}</h3>
                  </div>
                ))}              
            </div>
            <Markdown className="bottom-text-box max-w-[800px] w-full mx-auto font-lato font-normal text-xl text-black text-center">{attr.richText}</Markdown>
          </div>
        </section>
        {attr.downloadsSection && <DownloadsSection data={attr.downloadsSection} />}
        {attr.bannerSection && 
          <section className="mt-10">
            <Banner data={attr.bannerSection} />
          </section>
        }
        <Footer data={props.footer} />
      </div>
    </Fragment>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  try {
    const page = await axios({
      method: HTTPMethod.GET,
      baseURL: Env.ApiUrl,
      url: '/software-download-page',
      params: { populate: 'deep' },
    }).then((resp) => Converters.KeysConvert.ToLowerCase(resp.data))

    const footer = await axios({
      method: HTTPMethod.GET,
      baseURL: Env.ApiUrl,
      url: '/menus/2',
      params: { populate: 'deep' },
    }).then((resp) => Converters.KeysConvert.ToLowerCase(resp.data))

    if (!page.data) {
      return { notFound: true }
    }

    return { props: { page, footer }, revalidate: Env.PropsRevalidateTime }
  } catch (error) {
    return { notFound: true }
  }
}
